// src/utils/inventory/keyUtils.js

export function stableStringify(value) {
  const seen = new WeakSet();

  const sorter = (val) => {
    if (val && typeof val === "object") {
      if (seen.has(val)) return "[Circular]";
      seen.add(val);

      if (Array.isArray(val)) return val.map(sorter);

      const out = {};
      Object.keys(val)
        .sort()
        .forEach((k) => {
          out[k] = sorter(val[k]);
        });
      return out;
    }
    return val;
  };

  try {
    return JSON.stringify(sorter(value));
  } catch {
    return String(value);
  }
}

export function toDisplayLabel(value) {
  if (value == null) return "Unknown";
  if (typeof value === "string") return value;
  if (typeof value === "number" || typeof value === "boolean" || typeof value === "bigint") {
    return String(value);
  }

  if (typeof value === "object") {
    const name =
      value.company_name ||
      value.companyName ||
      value.name ||
      value.title ||
      value.label ||
      value.displayName;
    if (name != null) return String(name);

    const id = value.id || value.company_id || value.companyId || value.user_id;
    if (id != null) return `ID ${String(id)}`;

    const s = stableStringify(value);
    return s.length > 60 ? s.slice(0, 57) + "…" : s;
  }

  return String(value);
}

export function toStableKey(value) {
  if (value == null) return "unknown";

  if (typeof value === "string") return `s:${value}`;
  if (typeof value === "number") return `n:${value}`;
  if (typeof value === "boolean") return `b:${value}`;
  if (typeof value === "bigint") return `bi:${value.toString()}`;

  if (typeof value === "object") {
    const id = value.id || value.company_id || value.companyId || value.user_id || value.userId;
    if (id != null) return `id:${String(id)}`;
    return `o:${stableStringify(value)}`;
  }

  return `x:${String(value)}`;
}
